import React, { PureComponent, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Form from '../../shared/forms/form.component';
import schema from './businessUnitForm.schema';
import { BusinessUnitPropTypes } from '../../shared/propTypes/businessUnits';
import Modal from '../../shared/modals/modal.component';

import {
  businessUnitsOptionsSelector,
} from './store/selectors';

import {
  hideAddEditModal,
  saveBusinessUnit,
} from './store/actions';

const ModalTitles = {
  ADD: 'Add Business Unit',
  EDIT: 'Edit Business Unit',
};

class AddBusinessUnitModal extends PureComponent {
  static propTypes = {
    fetchInitialDataForBusinessUnitModal: PropTypes.func.isRequired,
    hideAddEditModal: PropTypes.func.isRequired,
    saveBusinessUnit: PropTypes.func.isRequired,
    enabledFlagOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    businessCodeOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      businessDescription: PropTypes.string.isRequired,
    })).isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isLoadingInitialData: PropTypes.bool.isRequired,
    entityToEdit: BusinessUnitPropTypes,
    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool.isRequired,
    businessUnitOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
  };

  state = {
    addAnother: false,
  };

  saveBusinessUnit = (businessUnitData, { setSubmitting, resetForm }) => {
    const { period, saveBusinessUnit, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, async () => {
      await saveBusinessUnit({
        businessUnitData,
        period,
        leaveModalOpen: addAnother,
        isEditMode: openForEdit,
      }, resetForm);
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      enabledFlagOptions,
      businessCodeOptions,
      businessUnitOptions,
      isSavingInProgress,
      isVisible,
      openForEdit,
      hideAddEditModal,
      isLoadingInitialData,
    } = this.props;

    const submit = useCallback(() => {
      this.setState({
        addAnother: false,
      }, async () => {
        formik.handleSubmit();
      });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const submitAndAddAnotherAction = useCallback(() => {
      this.setState({
        addAnother: true,
      }, () => {
        formik.handleSubmit();
      });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const reset = useCallback(() => {
      hideAddEditModal();
      formik.resetForm();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <Modal
        className="add-business-unit-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submit}
        submitDisabled={isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
        isLoading={isLoadingInitialData}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            enabledFlagOptions,
            businessCodeOptions,
            businessUnitOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const {
      entityToEdit,
      businessUnitOptions,
      openForEdit,
    } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.saveBusinessUnit}
        render={this.renderModal}
        validationContext={{ businessUnitOptions, openForEdit }}
      />
    );
  }
}

function mapStateToProps(state) {
  const { administration } = state;
  return {
    businessUnitOptions: businessUnitsOptionsSelector(state),
    isSavingInProgress: administration.businessUnitSettings.isSavingInProgress,
  };
}

export default connect(
  mapStateToProps,
  {
    hideAddEditModal,
    saveBusinessUnit,
  }
)(AddBusinessUnitModal);
